import { z } from 'zod';

// Request schemas

export const CustomerSearchFiltersSchema = z.object({
  search: z.string().optional(),
  page: z.number().min(1).default(1),
  pageSize: z.number().min(1).max(100).default(20),
  showFavoritesOnly: z.boolean().optional(),
});